import React from 'react';
import './Loading.css'

function Loading() {
  return (
    <div style={{width: '100%', marginTop: '100px', zIndex: '10', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
    <div className="pl">
      <div className="pl__bars">
        <div className="pl__bar">
          <div className="pl__bar-s"></div>
          <div className="pl__bar-t"></div>
          <div className="pl__bar-l"></div>
          <div className="pl__bar-r"></div>
        </div>
        <div className="pl__bar">
          <div className="pl__bar-s"></div>
          <div className="pl__bar-t"></div>
          <div className="pl__bar-l"></div>
          <div className="pl__bar-r"></div>
        </div>
        <div className="pl__bar">
          <div className="pl__bar-s"></div>
          <div className="pl__bar-t"></div>
          <div className="pl__bar-l"></div>
          <div className="pl__bar-r"></div>
        </div>
        <div className="pl__bar">
          <div className="pl__bar-s"></div>
          <div className="pl__bar-t"></div>
          <div className="pl__bar-l"></div>
          <div className="pl__bar-r"></div>
        </div>
      </div>
    </div>
    
    <h4 className='loading-h4'>Getting Data...</h4>
    </div>
  );
}

export default Loading;
